import HappyLogo from "../assets/happy-logo.png";
export default function Approved() {

    return (
        <div style={{display:"flex",flexDirection:"column",width:"100%",minHeight:"100svh",justifyContent:"center" ,alignItems:"center",backgroundColor:"#A2C654",gap:"0"}}>
        <img src={HappyLogo} alt="Happy Logo" style={{height:"150px"}}/>
        <h1 style={{fontFamily:"poppins , Arial",color:"white",textAlign:"center"}}>Your transaction has been approved</h1>
        <p style={{fontFamily:"poppins , Arial",color:"white",textAlign:"center"}}>You can close this page and go back to enjoying your meals</p>

        </div>
    );
}

